import { render, staticRenderFns } from "./SpecialRfDg.vue?vue&type=template&id=caffda56&scoped=true"
import script from "./SpecialRfDg.vue?vue&type=script&lang=js"
export * from "./SpecialRfDg.vue?vue&type=script&lang=js"
import style0 from "./SpecialRfDg.vue?vue&type=style&index=0&id=caffda56&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caffda56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caffda56')) {
      api.createRecord('caffda56', component.options)
    } else {
      api.reload('caffda56', component.options)
    }
    module.hot.accept("./SpecialRfDg.vue?vue&type=template&id=caffda56&scoped=true", function () {
      api.rerender('caffda56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/SpecialRfDg.vue"
export default component.exports